import { jsx } from 'react/jsx-runtime';
import { Label as Label$1 } from '@radix-ui/react-label';
import clsx from 'clsx';
import { Text } from '../../../Text/Text.js';
import { LABEL_SIZE_MAP } from './Label.constants.js';

function Label({
  asChild = false,
  checked = false,
  children,
  id,
  size
}) {
  return jsx(Label$1, {
    asChild: asChild,
    className: clsx('flex select-none items-center transition-colors duration-hover', LABEL_SIZE_MAP[size], checked ? 'text-navy' : 'text-gray'),
    htmlFor: id,
    children: jsx(Text, {
      as: "span",
      fontWeight: "semibold",
      variant: size === 'default' ? 'p1' : 'h3',
      children: children
    })
  });
}

export { Label };
